import { Component, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { ApiService } from '../api.service';
import { CacheService } from '../cache.service';
import { CourseService } from '../course.service';
import { CourseObjectivesService } from '../course-objectives.service';
import { CourseObjective } from '../course-objective.model';
import { whitespaceValidator } from '../whitespace-validator';



@Component({
selector: 'app-course-objective',
templateUrl: './course-objective.component.html',
styleUrls: ['./course-objective.component.scss']
})
export class CourseObjectiveComponent implements OnInit {
    @Input() objective: CourseObjective;
    // @Output() cancelAdd = new EventEmitter<boolean>();

    form;
    isAdd: boolean = false;
    isLoading: boolean = false;
    isLoaded: boolean = false;
    isSubmitted: boolean = false;
    isSaving: boolean = false;
    isDeleting: boolean = false;
    isValid: boolean = false;
    isEditable: boolean = false;
    loadingError: string = '';
    loadingMsg: string = '';
    errorMessage: string = '';
    display: boolean = false;

    constructor(
        private apiService: ApiService,
        private cacheService: CacheService,
        private courseService: CourseService,
        private courseObjectivesService: CourseObjectivesService,
        // private fileUploadService: FileUploadService,
        private fb: FormBuilder
    ) {}

    ngOnInit() {
        this.isAdd = !this.objective;
        if (this.isAdd) {
            this.objective = new CourseObjective({});
            this.isEditable = true;
            this.isLoaded = true;
            this.display = true;
        }
        this.prepareForm();
    }

    prepareForm() {
        this.form = this.fb.group({
            id: [this.objective.id, []],
            sortOrder: [this.objective.sortOrder, []],
            description: [
                this.objective.description, 
                [Validators.required, Validators.minLength(5), Validators.maxLength(500), whitespaceValidator.emptyInput],
            ],
        });

        this.form.valueChanges.subscribe((value) => {
            this.isValid = this.form.dirty && !this.form.invalid;
        });
    }

    get() {
        if (this.isLoading) return;

        this.isEditable = false;
        this.isSaving = false;
        this.isLoading = true;
        this.loadingError = '';

        this.apiService.getCourseObjective(this.course, this.objective).subscribe(
            (data) => {
                this.objective = new CourseObjective(data);
                this.isLoaded = true;
                this.isLoading = false;
            },
            (error) => {
                this.isLoaded = true;
                this.isLoading = false;
                this.loadingError = error;
            }
        );
    }

    collapse() {
        if (this.isEditable) return;
        if (!this.isLoaded) this.get();
        this.display = !this.display;
    }

    edit() {
        this.prepareForm();
        this.isEditable = true;
        this.courseObjectivesService.isEditable = true;
    }

    cancel() {
        this.errorMessage = '';
        this.isEditable = false;
        this.courseObjectivesService.isEditable = false;
        this.courseObjectivesService.isAdd = false;
        this.form.reset(this.objective);
    }

    save() {
        this.isSubmitted = true;
        if ( this.form.invalid ) return;
        if ( this.form.invalid && (this.form.dirty || this.form.touched) ) return;
        if ( this.isSaving) return;
        this.isSaving = true;
        this.errorMessage = ``;

        if (!this.isAdd) {
            this.apiService
                .updateCourseObjective(this.course, this.form.value)
                .subscribe(
                    (data) => {
                        this.courseObjectivesService.isAdd = false;
                        this.courseObjectivesService.isEditable = false;
                        this.courseObjectivesService.get();
                    },
                    (error) => {
                        this.errorMessage = error;
                        this.isSaving = false;
                    }
                );
            return;
        }

        this.apiService
            .createCourseObjective(this.course, this.form.value)
            .subscribe(
                (data) => {
                    this.courseObjectivesService.isAdd = false;
                    this.courseObjectivesService.isEditable = false;
                    this.courseObjectivesService.get();
                },
                (error) => {
                    this.errorMessage = error;
                    this.isSaving = false;
                }
            );
    }

    move(direction) {
        const sortOrder = (direction === 'up') ? this.objective.sortOrder - 1 : this.objective.sortOrder + 1;
        this.sortOrder.patchValue(sortOrder);
        this.save();
    }

    delete() {
        if ( this.isDeleting) return;
        if ( !confirm(`Are you sure you would like to remove this Objective from this Course?`) ) return;
        this.isDeleting = true;
        this.errorMessage = ``;

        this.apiService
            .deleteCourseObjective(this.course, this.objective)
            .subscribe(
                (data) => {
                    this.isDeleting = false;
                    this.courseObjectivesService.get();
                },
                (error) => {
                    this.errorMessage = error;
                    this.isDeleting = false;
                }
            );
    }
    
    open(url){
        window.open(url, "_blank");
    }

    get course() {
        return this.courseService.course;
    }

    get sortOrder() {
        return this.form.get('sortOrder');
    }

    get description() {
        return this.form.get('description');
    }

    get objectives() {
        return this.courseObjectivesService.objectives;
    }

}
